import OfferEvent from '@core/models/offer/OfferEvent';
import { getFlagByCategory } from '@sportOfferFederation/flags/flagMapping';
import {
    computed,
    ComputedRef,
    Ref,
} from '@vue/composition-api';

const maximumNumberOfFlags = 3;

interface MEBBPreviewService {
    flags: ComputedRef<string[]>;
    numberOfCompetitions: ComputedRef<number>;
}

export const useMEBBPreview = (topBetBuilderEvents: Ref<Pick<OfferEvent, 'categoryId' | 'tournamentId'>[]>): MEBBPreviewService => {
    const flags = computed(() => Array.from(new Set(topBetBuilderEvents.value.map(({ categoryId }) => getFlagByCategory(categoryId)))).slice(0, maximumNumberOfFlags));

    const numberOfCompetitions = computed(() => {
        return new Set(topBetBuilderEvents.value.map(({ tournamentId }) => tournamentId)).size;
    });

    return {
        flags,
        numberOfCompetitions,
    };
};
